import { useEffect, useState } from "react";

export const useScenarioQuestions = ( generatedQuestionsFromSubmitContent ) => {

  const [scenarioQuestions, setScenarioQuestions] = useState([]);

  const handleScenarioQuestionChange = (index, newValue) => {
    const updatedQuestions = [...scenarioQuestions];
    updatedQuestions[index].Question = newValue;
    setScenarioQuestions(updatedQuestions);
  };

  const handleScenarioAnswerChange = (index, newValue) => {
    const updatedQuestions = [...scenarioQuestions];
    updatedQuestions[index].Answer = newValue;
    setScenarioQuestions(updatedQuestions);
  };

  const handlescenarioQuestionsEdit = (index) => {
    const updatedQuestions = [...scenarioQuestions];
    updatedQuestions[index].editing = !updatedQuestions[index].editing;

    if (updatedQuestions[index].editing) {
      // After setting editing to true, focus on the contentEditable div for the question
      setTimeout(() => {
        const contentEditableElement = document.getElementById(
          `question-${index}`
        ); // Add an ID to your contentEditable element
        if (contentEditableElement) {
          contentEditableElement.focus();
        }
      }, 0);
    }

    setScenarioQuestions(updatedQuestions);
  };

  const handleScenarioAnswersEdit = (index) => {
    const updatedQuestions = [...scenarioQuestions];
    if (updatedQuestions[index]) {
      updatedQuestions[index].editingAnswer =
        !updatedQuestions[index].editingAnswer;
      setScenarioQuestions(updatedQuestions);
    }
  };

  const handleScenarioQuestionDelete = (index) => {
    let updatedQuestions = [...scenarioQuestions];
    updatedQuestions.splice(index, 1); // Remove the question at the given index
    setScenarioQuestions(updatedQuestions);
  };

   function removeDuplicateQuestions(input) {
    const seen = new Set();
  
    // Normalize input to always be an array
    const questionsArray = Array.isArray(input)
      ? input
      : input?.questions || [];
  
    return questionsArray.filter((q) => {
      const text = (q.Question ?? q.question ?? "").toLowerCase().replace(/\s+/g, " ").trim();
      if (seen.has(text)) return false;
      seen.add(text);
      return true;
    });
  }

  useEffect(() => {
    if (generatedQuestionsFromSubmitContent) {

      var scenario_based_questions = 
      generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.scenario_based_questions ||
      generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.questionset?.scenario_based_questions ||
       generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.scenario_based_questions?.questions ||
        generatedQuestionsFromSubmitContent?.questions?.questionset?.scenario_based_questions?.questions ||
        generatedQuestionsFromSubmitContent?.questions?.questionset?.questionset?.scenario_based_questions?.questions ||
          generatedQuestionsFromSubmitContent.response?.scenario_based_questions ||
          generatedQuestionsFromSubmitContent?.scenario_based_questions?.questions ||
          []
        scenario_based_questions =  removeDuplicateQuestions(scenario_based_questions);
      setScenarioQuestions(scenario_based_questions);
    }
  }, [generatedQuestionsFromSubmitContent]);

  return {
    scenarioQuestions,
    handleScenarioQuestionChange,
    handleScenarioAnswerChange,
    handlescenarioQuestionsEdit,
    handleScenarioAnswersEdit,
    handleScenarioQuestionDelete,
  };
};
